interface RestartToFinishSetupModalProps {
  onConfirmRestart: () => void;
  onDismiss: () => void;
}

export const RestartToFinishSetupModal = ({ onConfirmRestart, onDismiss }: RestartToFinishSetupModalProps) => (
  <>
    <div className='absolute inset-0 z-40 rounded-[12px] bg-[#181818] opacity-[0.72]' />
    <div className='absolute inset-0 z-50 flex items-center justify-center p-4'>
      <div className='w-full rounded-[10px] border border-[#e4e4e4]/12 bg-[#181818] p-5'>
        <div className='flex w-full flex-col items-center gap-3'>
          <p className='m-0 text-center text-[20px] font-[590] leading-[26px] text-[#e4e4e4]/92'>
            Restart to finish setup
          </p>
          <p className='m-0 text-center text-[14px] font-normal leading-[20px] text-[#e4e4e4]/55'>
            This PC needs a restart before Host Mode can switch to the guest account.
          </p>
          <button
            type='button'
            onClick={onConfirmRestart}
            className='w-full min-h-[44px] rounded-full border-none bg-[#FBBF24] px-4 py-3 text-[15px] font-semibold text-[#141414] cursor-pointer transition-transform hover:scale-[1.02] active:scale-[0.98]'
          >
            Restart now
          </button>
          <button
            type='button'
            onClick={onDismiss}
            className='flex w-full items-center justify-center rounded-full border border-transparent bg-transparent px-1.5 py-0 text-[14px] font-medium leading-[20px] text-[#e4e4e4]/55 cursor-pointer transition-colors hover:text-[#e4e4e4]/80'
            style={{ height: 24 }}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  </>
);
